import { BoltIcon } from "../components/BoltIcon";
import { LockIcon } from "../components/LockIcon";
import { QuestionIcon } from "../components/QuestionIcon";

export const complianceTermsContentData = [
  {
    icon: QuestionIcon,
    title: 'What to expect',
    text: 'After clicking "Link my Policy", you can select your insurance provider and log in to access your policy. Once selected, we will verify if your policy meets your building\'s requirements then notify your landlord once verified.',
  },
  {
    icon: BoltIcon,
    title: 'Instant verification',
    text: "By linking your renters insurance policy, TheGuarantors can instantly verify if you meet your building's requirements.",
  },
  {
    icon: LockIcon,
    title: 'Your information is private',
    text: 'TheGuarantors will never share your credentials or sell your information. Only the information you select to share will be sent to TheGuarantors.',
  },
];
